import { Button } from 'component/Button'
import { Img } from 'component/Image'
import { Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { Page } from 'page/Page/Page'
import { controller } from 'store/controller'
import { store } from 'store/store'
import css from './ExistingScreen.module.scss'

export const ExistingScreen = observer(() => {
  const { inference } = store.existing
  const { source, pic } = inference

  const onView = useLatestCallback(() => {
    controller.openInference(inference, 'all')
  })

  const onProfile = useLatestCallback(async () => {
    controller.editProfile()
  })

  return (
    <Page full clear center>
      <Vertical className={css.screen} gap={16} pad={[0, 16]} wide tall>
        <Vertical className={css.main} tall spring center>
          <Img src={source} className={css.image} />
          <Space className={css.circle}>
            <Space className={css.ring}>
              <Img className={css.pic} src={pic} />
            </Space>
          </Space>
        </Vertical>
        <Vertical gap={8}>
          <Typo size={16} semi center>
            {i18n('OutfitAlreadySet')}
          </Typo>
          <Typo size={14} secondary center>
            {i18n('YouAlreadyHaveOutfitForThisProfilePhoto')}
          </Typo>
        </Vertical>
        <Vertical gap={12}>
          <Button large primary action={onView}>
            {i18n('GoToTheLook')}
          </Button>
          <Button large flat action={onProfile}>
            {i18n('UploadAnotherPhoto')}
          </Button>
        </Vertical>
      </Vertical>
    </Page>
  )
})
